import { tracking, _t } from '@bark/bark-core'
import {currency} from "@bark/bark-core/src/helpers/number-formatting";

export function getLocalEstimateValue(quoteValue) {
    if (quoteValue) {
        quoteValue = currency(quoteValue, true);
    }
    return quoteValue;
}

export function getLocalEstimateString(quoteValue, quoteFrequency) {
    let quoteString = '';
    if (!quoteValue && !quoteFrequency) {
        return quoteString;
    }
    quoteValue = getLocalEstimateValue(quoteValue);
    switch (quoteFrequency) {
        case 'day':
            quoteString = _t("seller_responses:quote-data.per-day", {
                quote_value: quoteValue
            });
            break;
        case 'head':
            quoteString = _t("seller_responses:quote-data.per-head", {
                quote_value: quoteValue
            });
            break;
        case 'hour':
            quoteString = _t("seller_responses:quote-data.per-hour", {
                quote_value: quoteValue
            });
            break;
        case 'month':
            quoteString = _t("seller_responses:quote-data.per-month", {
                quote_value: quoteValue
            });
            break;
        case 'onceoff':
            quoteString = _t("seller_responses:quote-data.one-off-fee", {
                quote_value: quoteValue
            });
            break;
        case 'session':
            quoteString = _t("seller_responses:quote-data.per-session", {
                quote_value: quoteValue
            });
            break;
        case 'visit':
            quoteString = _t("seller_responses:quote-data.per-visit", {
                quote_value: quoteValue
            });
            break;
        case 'week':
            quoteString = _t("seller_responses:quote-data.per-week", {
                quote_value: quoteValue
            });
            break;
        default:
            quoteString = quoteValue;
    }
    return quoteString;
}

export function SendEstimate() {
	let Bark = (window.Bark = window.Bark || {});

	Bark.sendEstimate = {
		buyerUserId: null,
		projectResponseId: null,
		responseId: null,
		submitting: false,
		successCallback: null,

		/**
		 * Various click event handlers
		 */
		initClickHandlers() {
			$('.button-send-estimate')
				.off('click')
				.on('click', () => {
					Bark.sendEstimate.validateEstimate();
				});

			return this;
		},

		/**
		 * Listen for specific modal events
		 */
		initModals() {
			$('#barkSendEstimateModal').on('hidden.bs.modal', () => {
				if (!Bark.sendEstimate.submitting) {
					Bark.logEvent('send-estimate', 'close-modal', 'seller-response-flow');
				}
			});
			$('#barkSendEstimateModal').on('shown.bs.modal', () => {
				if (!Bark.isMobile()) {
					$('#estimate-amount').focus();
				}
			});
			return this;
		},

		/**
		 * Registars a callback function to call when this step is complete
		 * @param {function} executable
		 */
		registerSuccessCallback(executable) {
			Bark.sendEstimate.successCallback = executable;
		},

		/**
		 * Resets everything when a new lead is selected
		 * @param {object} options Reset options
		 * @returns {window.Bark.sendEstimate}
		 */
		resetStatus(options = {}) {
			const {
				responseId,
				buyerUserId = null,
				estimateAmount = '',
				estimateType = null,
				estimateMessage = '',
			} = options;
			Bark.sendEstimate.setErrorMessage();
			Bark.sendEstimate.responseId = responseId;
			Bark.sendEstimate.buyerUserId = buyerUserId;

			// Set the quote amount and type
			$('#barkSendEstimateModal .estimate-amount').val(estimateAmount);
			$('#barkSendEstimateModal #estimate-type').val(estimateType);
			$('#barkSendEstimateModal #respond-textarea-field').val(estimateMessage);
			$('#barkSendEstimateModal button span.action').text(
                parseFloat(estimateAmount) > 0
                    ? _t("seller_send-estimate-modal:update-estimate-button")
                    : _t("seller_send-estimate-modal:send-estimate-button")
			);

			// Close the modal if it is open
			$('#barkSendEstimateModal').modal('hide');
			$('#barkSendEstimateModal .modal-submit')
				.removeClass('submit-waiting')
				.prop('disabled', false);

			this.submitting = false;

			return this;
		},

		/**
		 * Shows an error message within the modal
		 * @param {string|null} message The message to display
		 */
		setErrorMessage(message = null) {
			if (message) {
				$('#barkSendEstimateModal .error-custom').text(message).removeClass('d-none');
			} else {
				$('#barkSendEstimateModal .error-custom').addClass('d-none');
			}
		},

		/**
		 * Shows the Call Buyer modal
		 */
		showModal() {
			const estimateAmount = $('#barkSendEstimateModal .estimate-amount').val();
			Bark.sendEstimate.setErrorMessage();
			$('#barkSendEstimateModal .modal-submit')
				.removeClass('submit-waiting')
				.prop('disabled', false);
			$('#barkSendEstimateModal').modal('show');
			this.submitting = false;
			$('#barkSendEstimateModal button span.action').text(
                parseFloat(estimateAmount) > 0
                    ? _t("seller_send-estimate-modal:update-estimate-button")
                    : _t("seller_send-estimate-modal:send-estimate-button")
            );
			if (Bark.sellerResponseFlow) {
				tracking(
					'seller-leads-dashboard-&-responses',
					`${estimateAmount > 0 ? 'Update' : 'Send'} reference quote - view`,
					{
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					},
				);
			}
		},

		/**
		 * Submits the estimate to the API.
		 */
		submitEstimate() {
			const quote = +$(
					'#barkSendEstimateModal .respond-message-estimate .estimate-amount',
				).val(),
				quoteType = $(
					'#barkSendEstimateModal .respond-message-estimate .estimate-type',
				).val(),
				msg = $('#barkSendEstimateModal #respond-textarea-field').val(),
				submitButton = $('#barkSendEstimateModal .modal-submit');

			submitButton.addClass('submit-waiting').prop('disabled', true);
			this.submitting = true;

			Bark.api(
				'response/estimate/',
				{
					resp_id: Bark.sendEstimate.responseId,
					quote: quote.toFixed(2),
					type: quoteType,
					detail: msg,
				},
				(data) => {
					const currencySymbol = $('#estimate-currency-symbol').text() || '£';
					if (data.status) {
						$('#barkSendEstimateModal').modal('hide');

						if (typeof Bark.sendEstimate.successCallback == 'function') {
							const quoteFormattedFull =
								data && data.formatted_quote_full
									? data.formatted_quote_full
									: currencySymbol +
									  quote.toFixed(2) +
									  (quoteType === 'onceoff'
											? ` ${_t('common:pricing-intervals.oneoff-fee')}`
											: ' / ' + quoteType);
							Bark.sendEstimate.successCallback(quoteFormattedFull);
						}
						if (Bark.sellerResponseFlow && Bark.sellerResponseFlow.projectId) {
							tracking(
								'seller-leads-dashboard-&-responses',
								'Send reference quote - success',
								{
									pagename: window.location.pathname,
									project_id: Bark.sellerResponseFlow.projectId,
									lead_type: 'project',
									project_response_id: Bark.sendEstimate.responseId,
								},
							);
						}
					} else {
						// Should never get here, as an error would be handled by the failure callback. But making sure we show some error messaging.
						Bark.sendEstimate.setErrorMessage(
							_t('seller_send-estimate-modal:error.failed-to-send'),
						);
						submitButton.removeClass('submit-waiting').prop('disabled', false);
						Bark.logEvent('send-estimate', 'api-error', 'seller-response-flow');
						this.submitting = false;
					}
				},
				(data) => {
					Bark.hideLoading();
					// Error in the estimate form
					let errorMessage = 'An error occurred while sending your estimate';
					if (
						data.responseJSON &&
						data.responseJSON.error &&
						data.responseJSON.error.errors
					) {
						const errors = data.responseJSON.error.errors;
						let messages = [];
						for (let key in errors) {
							if (errors.hasOwnProperty(key)) {
								messages.push(errors[key].pop());
							}
						}
						errorMessage = messages.join('. ');
					}
					Bark.sendEstimate.setErrorMessage(errorMessage);
					submitButton.removeClass('submit-waiting').prop('disabled', false);
					Bark.logEvent('send-estimate', 'api-error', 'seller-response-flow');
					this.submitting = false;
					return false;
				},
				'POST',
			);
		},

		/**
		 * Validates the estimate form fields.
		 * @returns {boolean}
		 */
		validateEstimate() {
			const quote = +$(
					'#barkSendEstimateModal .respond-message-estimate .estimate-amount',
				).val(),
				quoteType = $(
					'#barkSendEstimateModal .respond-message-estimate .estimate-type',
				).val();
			let errorMessage = null;

			if (!Bark.sendEstimate.responseId) {
				bugsnagClient.notify(new Error('Missing response ID in send estimate modal'));
				Bark.logEvent('send-estimate', 'validation-error', 'seller-response-flow');
				return false;
			}

			if (!quote) {
				errorMessage = _t("seller_send-estimate-modal:error.empty");
			} else if (!quoteType) {
				errorMessage = _t("seller_send-estimate-modal:error.missing-quote")
			}

			Bark.sendEstimate.setErrorMessage(errorMessage);

			if (!errorMessage) {
				Bark.sendEstimate.submitEstimate();
			} else {
				Bark.logEvent('send-estimate', 'validation-error', 'seller-response-flow');
			}
		},
	};

	$(document).ready(() => {
		Bark.sendEstimate.initClickHandlers().initModals().resetStatus();
	});
}
